import React from "react";
import { useMemo } from "react";
import { formatDate } from "../../service/constants";

const MedicationStatementTextDetails = ({ medicationDetailData }) => {
  const startDate = useMemo(() => {
    return medicationDetailData?.resource?.extension?.find((item) =>
      item.url.includes("startPeriod")
    );
  }, [medicationDetailData.resource.extension]);
  const endDate = useMemo(() => {
    return medicationDetailData?.resource?.extension?.find((item) =>
      item.url.includes("endPeriod")
    );
  }, [medicationDetailData.resource.extension]);
  return (
    <div className="info-container">
      {/* {medicationDetailData.resource.medicationCodeableConcept?.coding[0]
        ?.display &&
        medicationDetailData.resource.medicationCodeableConcept?.text && (
          <div>
            <span className="label">Tablet Name - </span>
            {
              medicationDetailData.resource.medicationCodeableConcept?.coding[0]
                ?.display
            }
          </div>
        )}

      {!medicationDetailData.resource.medicationCodeableConcept?.coding[0]
        ?.display &&
        medicationDetailData.resource.medicationCodeableConcept?.text && (
          <div>
            <span className="label">Tablet Name - </span>
            {medicationDetailData.resource.medicationCodeableConcept?.text}
          </div>
        )} */}
      {medicationDetailData.resource?.medicationCodeableConcept.coding &&
        medicationDetailData.resource?.medicationCodeableConcept.coding && (
          <div>
            <span className="label">Tablet Name - </span>
            {
              medicationDetailData.resource?.medicationCodeableConcept.coding[0]
                .text
            }
          </div>
        )}

      {!medicationDetailData.resource?.medicationCodeableConcept.coding && (
        <div>
          <span className="label">Tablet Name - </span>
          {medicationDetailData.resource?.medicationCodeableConcept.text}
        </div>
      )}

      {medicationDetailData.resource.medicationCodeableConcept?.coding && (
        <div>
          <span className="label">Snowmed - </span>
          {
            medicationDetailData.resource.medicationCodeableConcept?.coding[0]
              .code
          }
        </div>
      )}

      {medicationDetailData.resource.dosage &&
        medicationDetailData.resource.dosage[0].text && (
          <div>
            <span className="label">Dosage - </span>
            {medicationDetailData.resource.dosage[0].text}
          </div>
        )}
      {medicationDetailData.resource.dosage &&
        medicationDetailData.resource.dosage[0].route && (
          <div>
            <span className="label">Direction - </span>
            {medicationDetailData.resource.dosage[0].route.coding[0].display}
          </div>
        )}

      {medicationDetailData.resource.dosage &&
        medicationDetailData.resource?.dosage[0]?.timing && (
          <div>
            <span className="label">Frequency - </span>
            {medicationDetailData.resource.dosage[0].timing.repeat.frequency}
          </div>
        )}
      {medicationDetailData.resource.status && (
        <div>
          <span className="label">
            {" "}
            {medicationDetailData.resource.status === "active"
              ? "Current Medication"
              : "Past Medication"}{" "}
          </span>
        </div>
      )}

      {medicationDetailData.resource.dosage &&
        medicationDetailData.resource.dosage[0].doseAndRate[0].doseQuantity && (
          <div>
            <span className="label">Dose Quantity - </span>
            {
              medicationDetailData.resource.dosage[0].doseAndRate[0]
                .doseQuantity.value
            }
          </div>
        )}
      {startDate && (
        <div>
          <span className="label">Start Period - </span>
          {formatDate(startDate.valueCode)}
        </div>
      )}
      {endDate && (
        <div>
          <span className="label">End Period - </span>
          {formatDate(endDate.valueCode)}
        </div>
      )}
    </div>
  );
};

export default MedicationStatementTextDetails;
